module.exports = __webpack_public_path__ + "img/FR40031.744ac65d.png";